import { render, staticRenderFns } from "./ChangeViaEmail.vue?vue&type=template&id=8be96bf8&"
import script from "./ChangeViaEmail.vue?vue&type=script&lang=js&"
export * from "./ChangeViaEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports